module.exports = __webpack_public_path__ + "static/media/navigation_flow.b807ff27.jpg";